import { render, staticRenderFns } from "./ListLeads.vue?vue&type=template&id=fa91020e&scoped=true&"
import script from "./ListLeads.vue?vue&type=script&lang=js&"
export * from "./ListLeads.vue?vue&type=script&lang=js&"
import style0 from "./ListLeads.vue?vue&type=style&index=0&id=fa91020e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa91020e",
  null
  
)

export default component.exports